export default __webpack_public_path__ + "static/media/logo-with-name.abb097ee.svg";